import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
import './PortfolioPage.css';
import nafty1 from '../assets/nafty/modified_image.png';
import nafty2 from '../assets/nafty/nafty_main.png';
import nafty3 from '../assets/nafty/modified_image (2).png';
import nafty4 from '../assets/nafty/modified_image (4).png';
import nafty5 from '../assets/nafty/modified_image (5).png';
import nafty6 from '../assets/nafty/modified_image (6).png';
import nafty7 from '../assets/nafty/modified_image (7).png';
import nafty8 from '../assets/nafty/modified_image (8).png';
import destake1 from '../assets/destake/modified_image (3).png';
import destake2 from '../assets/destake/modified_image (9).png';
import destake3 from '../assets/destake/Screenshot (915).png';
import destake4 from '../assets/destake/Screenshot (916).png';
import destake5 from '../assets/destake/Screenshot (917).png';
import destake6 from '../assets/destake/Screenshot (918).png';
import destake7 from '../assets/destake/Screenshot (919).png';
import edumetrixMain from '../assets/edumetrix/modified_image (90).png';
import decrowd1 from '../assets/decrowd/modified_image (34).png';
import gojourney1 from '../assets/gouniquejourney/modified_image (38).png';
import linkedbricks1 from '../assets/linkedbricks/React App - Google Chrome 2024-03-19 22-43-54.mp4';
import nftmarketplace1 from '../assets/nftmarketplace/SaiNFT - NFT Marketplace - Google Chrome 2023-10-27 16-18-02.mp4';
import enteka1 from '../assets/enteka/modified_image - 2025-11-19T201633.637.png';
import mingo1 from '../assets/mingo/modified_image - 2025-11-20T160637.607.png';
import blinkit1 from '../assets/blinkit/modified_image - 2025-11-21T191943.401.png';
import blinkit2 from '../assets/blinkit/modified_image - 2025-11-21T192917.579.png';
import blinkit3 from '../assets/blinkit/modified_image - 2025-11-21T192921.429.png';
import blinkit4 from '../assets/blinkit/modified_image - 2025-11-21T193140.905.png';
import blinkit5 from '../assets/blinkit/modified_image - 2025-11-21T193210.782.png';
import blinkit6 from '../assets/blinkit/modified_image - 2025-11-21T193316.686.png';
import blinkit7 from '../assets/blinkit/modified_image - 2025-11-21T193851.905.png';
import blinkit8 from '../assets/blinkit/Screenshot (924).png';
import blinkit9 from '../assets/blinkit/Screenshot (925).png';
import blinkit10 from '../assets/blinkit/Screenshot (926).png';
import jobiva1 from '../assets/jobiva/modified_image - 2025-11-24T192219.674.png';
import learngenix1 from '../assets/learngenix/modified_image - 2025-11-26T171159.475.png';

const PortfolioPage = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.05
  });

  const [activeFilter, setActiveFilter] = useState('all');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const projects = [
    {
      id: 1,
      title: 'DeStake',
      category: 'blockchain',
      client: 'DeFi Project',
      year: '2024',
      description: 'Decentralized application for ERC20 token staking with per-second rewards based on stake amount and duration',
      longDescription: 'Engineered DeStake, a decentralized application for ERC20 token staking, generating per-second rewards based on stake amount and duration through smart contract automation.',
      tags: ['React', 'Vite', 'Solidity', 'Ethers.js'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      image: destake3,
      images: [destake1, destake2, destake3, destake4, destake5, destake6, destake7],
      results: {
        metrics: ['Automated per-second rewards', 'Smart contract-based rewards', 'Modern UI with React'],
        testimonial: 'A comprehensive DeFi staking solution with automated rewards.'
      }
    },
    {
      id: 2,
      title: 'Nafty',
      category: 'blockchain',
      client: 'Web3 Social Platform',
      year: '2024',
      description: 'Blockchain + AI social media app for minting, buying, selling, and sharing NFTs (ERC721) with social features',
      longDescription: 'Created a blockchain + AI social media app for minting, buying, selling, and sharing NFTs (ERC721), with social features like likes & comments. Integrated Gemini API for generating content.',
      tags: ['React', 'Solidity', 'Web3.js', 'Ethereum', 'Remix IDE', 'Tailwind CSS', 'Gemini API'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      image: nafty2,
      images: [nafty1, nafty2, nafty3, nafty4, nafty5, nafty6, nafty7, nafty8],
      results: {
        metrics: ['NFT minting and trading', 'AI-powered content generation', 'Social engagement features'],
        testimonial: 'Innovative fusion of blockchain, AI, and social media.'
      }
    },
      {
      id: 3,
      title: 'Go Unique Journeys',
      category: 'web',
      client: 'UK Travel Agency',
      year: '2024',
      description: 'Full-featured travel booking system with user, employee, and admin dashboards, and custom CMS',
      longDescription: 'Led a team of 3–4 developers to deliver a full-featured travel booking system for client in UK with user, employee, and admin dashboards, and a custom CMS for content and booking management.',
      tags: ['React', 'Next.js', 'Node.js', 'MongoDB', 'Redux'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
      image: gojourney1,
      results: {
        metrics: ['Real-time booking updates', 'Chatbot integration', 'VPS deployment with nginx'],
        testimonial: 'Professional travel booking solution with comprehensive management features.'
      }
    },
    {
      id: 4,
      title: 'EduMetrix Limited',
      category: 'web',
      client: 'UK EdTech',
      year: '2024',
      description: 'Full-fledged learning management system (LMS) with role-based portals for admins, teachers, and students',
      longDescription: 'Developed a full-fledged learning management system (LMS) for client in UK with role-based portals for admins, teachers, and students, utilizing the MERN stack (MongoDB, Express, React, Node.js).',
      tags: ['MERN Stack', 'Socket.io', 'Google Meet API', 'Calendar API'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      image: edumetrixMain,
      results: {
        metrics: ['Google Meet integration', 'Real-time messaging', 'Attendance & homework tracking'],
        testimonial: 'Comprehensive LMS with seamless live class integration.'
      }
    },
    {
      id: 5,
      title: 'Linked Bricks',
      category: 'web',
      client: 'UK Real Estate',
      year: '2024',
      description: 'Dynamic real estate platform with advanced search, map integration, and user dashboard',
      longDescription: 'Built dynamic real estate platforms for client in the UK with advanced search, map integration, and user dashboard. Developed RESTful APIs using Node.js, Express, and MongoDB.',
      tags: ['React', 'Redux', 'Node.js', 'MongoDB', 'Google Maps', 'Stripe'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      video: linkedbricks1,
      results: {
        metrics: ['Google Maps integration', 'Stripe payments', 'Real-time messaging with Socket.io'],
        testimonial: 'Feature-rich real estate platform with pixel-perfect UI.'
      }
    },
    {
      id: 6,
      title: 'DeCrowd',
      category: 'blockchain',
      client: 'Crowdfunding Platform',
      year: '2024',
      description: 'Blockchain-based crowdfunding platform with live contribution tracking, campaign management, and DAO governance',
      longDescription: 'Built a blockchain-based crowdfunding platform on Ethereum for campaign creation, live contribution tracking, and campaign history with DAO governance and user profiles.',
      tags: ['Solidity', 'Thirdweb', 'React', 'Context API', 'Tailwind CSS', 'Ethereum'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      image: decrowd1,
      results: {
        metrics: ['Decentralized governance', 'Real-time contribution tracking', 'Transparent campaign history'],
        testimonial: 'A trustless crowdfunding solution with complete transparency.'
      }
    },
    
  
    {
      id: 7,
      title: 'Enteka Shop',
      category: 'web',
      client: 'E-commerce',
      year: '2024',
      description: 'Full-featured online store with payment integration, user dashboards, and admin dashboard',
      longDescription: 'Developed full-featured online stores with payment integration, user dashboards, and admin dashboard using the MERN stack, Next JS & Redux.',
      tags: ['MERN Stack', 'Next.js', 'Redux', 'Payment Gateway'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      image: enteka1,
      results: {
        metrics: ['Payment integration', 'User & admin dashboards', 'Complete e-commerce features'],
        testimonial: 'Modern e-commerce solution with full management capabilities.'
      }
    },
    {
      id: 8,
      title: 'NFT Marketplace',
      category: 'blockchain',
      client: 'Web3 Platform',
      year: '2024',
      description: 'Decentralized NFT marketplace with Metamask authentication and Ethereum smart contracts',
      longDescription: 'Built a decentralized NFT marketplace using React.js, Redux, Web3.js, and Material UI, with a responsive UI, Firestore database, and Metamask authentication for secure user access and data management.',
      tags: ['React', 'Redux', 'Web3.js', 'Ethereum', 'Material UI', 'Firestore'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      video: nftmarketplace1,
      results: {
        metrics: ['Smart contract integration', 'GraphQL NFT APIs', 'Real-time blockchain interactions'],
        testimonial: 'Seamless NFT marketplace with secure Metamask integration.'
      }
    },
    {
      id: 9,
      title: 'Real-time Encrypted Chat',
      category: 'web',
      client: 'Chat Application',
      year: '2024',
      description: 'Real-time & end-to-end encrypted group chat application with room management',
      longDescription: 'Developed a real-time & end-to-end encrypted group chat application where user can create, update, delete & add member to room & can have group chat. Built using React, Typescript, Redux, Node.js, Express, MySQL, JWT, Socket.io, Crypto AES-256 & AWS S3.',
      tags: ['React', 'TypeScript', 'Node.js', 'MySQL', 'Socket.io', 'AES-256', 'AWS S3'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      image: mingo1,
      results: {
        metrics: ['End-to-end encryption', 'Real-time messaging', 'AWS S3 integration'],
        testimonial: 'Secure group chat with military-grade encryption.'
      }
    },
    
    {
      id: 10,
      title: 'E-commerce Platform',
      category: 'web',
      client: 'Online Store',
      year: '2024',
      description: 'Full-stack e-commerce platform with Firebase authentication and multiple payment gateways',
      longDescription: 'Developed an e-commerce platform using React, React Context API, Node.js, Express, Firebase, Stripe, Razorpay, React lazy loading, and Material UI. Implemented secure Firebase authentication, integrated Stripe and Razorpay for payments, and built features like a shopping cart, product reviews, image magnification, pagination, search, and filtering.',
      tags: ['React', 'Context API', 'Node.js', 'Firebase', 'Stripe', 'Razorpay', 'Material UI'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      image: blinkit1,
      images: [blinkit1, blinkit2, blinkit3, blinkit4, blinkit5, blinkit6, blinkit7, blinkit8, blinkit9, blinkit10],
      results: {
        metrics: ['Dual payment gateways', 'Firebase authentication', 'Advanced product features'],
        testimonial: 'Feature-rich e-commerce with multiple payment options.'
      }
    },
    
    {
      id: 11,
      title: 'Jobiva International',
      category: 'web',
      client: 'UK Recruitment Agency',
      year: '2024',
      description: 'Comprehensive recruitment platform with job listings, candidate management, and application tracking',
      longDescription: 'Developed a comprehensive recruitment platform for a UK-based international job agency, featuring job listings, candidate management, and application tracking with modern UI/UX design.',
      tags: ['React', 'Next.js', 'Node.js', 'MongoDB', 'Redux', 'Material UI'],
      demoLink: 'https://jobivainternational.com/',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      image: jobiva1,
      results: {
        metrics: ['Advanced job search', 'Employer dashboard', 'Application tracking'],
        testimonial: 'Professional recruitment platform that streamlined our hiring process.'
      }
    },
    {
      id: 12,
      title: 'Learngenix',
      category: 'web',
      client: 'EdTech Platform',
      year: '2024',
      description: 'AI powered educational course landing page website built using React, Next JS & CSS',
      longDescription: 'Developed an AI-powered educational course landing page website utilizing React, Next.js, and CSS. The platform provides an engaging user experience for showcasing educational courses with modern design and responsive layouts.',
      tags: ['React', 'Next.js', 'CSS', 'AI'],
      demoLink: 'https://learngenix.vercel.app/',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      image: learngenix1,
      results: {
        metrics: ['AI-powered content', 'Responsive design', 'Modern UI/UX'],
        testimonial: 'Innovative educational platform with AI integration.'
      }
    },
    {
      id: 13,
      title: 'DVote',
      category: 'blockchain',
      client: 'Voting Platform',
      year: '2024',
      description: 'Secure Ethereum voting platform with DAO governance and custom ERC-20 token for staking and rewards',
      longDescription: 'Built a secure Ethereum voting platform with DAO governance and a custom ERC-20 token; designed tokenomics with 0.001 ETH candidate staking and 50% reward distribution.',
      tags: ['Solidity', 'Hardhat', 'ERC-20', 'Next.js', 'Web3.js', 'Remix IDE', 'Tailwind CSS'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      results: {
        metrics: ['DAO governance', 'Custom tokenomics', 'Secure voting mechanism'],
        testimonial: 'Democratic and transparent voting with blockchain technology.'
      }
    },
    {
      id: 14,
      title: 'TweetCrypt',
      category: 'ai',
      client: 'Chrome Extension',
      year: '2024',
      description: 'Tweet virality predictor Chrome extension with AI/ML and blockchain, enabling users to bet on tweet virality',
      longDescription: 'Developed a Chrome extension with AI/ML and blockchain on the MERN stack, enabling users to bet on tweet virality with Ethereum-based rewards. Built ML models with 85% accuracy.',
      tags: ['MERN Stack', 'Machine Learning', 'Ethereum', 'Chrome Extension', 'Smart Contracts'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      results: {
        metrics: ['85% ML prediction accuracy', 'Ethereum-based betting', 'Chrome browser integration'],
        testimonial: 'Innovative combination of AI predictions and blockchain rewards.'
      }
    },
    {
      id: 15,
      title: 'Expense Tracker',
      category: 'web',
      client: 'Finance Management',
      year: '2024',
      description: 'Full-stack expense management system with premium accounts and data visualization',
      longDescription: 'Developed a full-stack expense management system using React.js, Redux/Redux Thunk, Node.js, Express, MongoDB, Razorpay, AWS S3, JWT, Chart.js, and Material UI. Implemented secure user authentication, premium account purchases, income and balance tracking, and data visualization.',
      tags: ['React', 'Redux', 'Node.js', 'MongoDB', 'Razorpay', 'Chart.js', 'AWS S3'],
      demoLink: '',
      githubLink: '',
      gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
      results: {
        metrics: ['Razorpay integration', 'Data visualization', 'AWS CSV export'],
        testimonial: 'Comprehensive expense tracker with premium features.'
      }
    },
  ];

  const filters = [
    { label: 'All Projects', value: 'all' },
    { label: 'Blockchain', value: 'blockchain' },
    { label: 'Web Apps', value: 'web' },
    { label: 'AI/ML', value: 'ai' }
  ];

  const filteredProjects = activeFilter === 'all'
    ? projects
    : projects.filter(project => project.category === activeFilter);

  return (
    <div className="portfolio-page">
      <section className="portfolio-hero">
        <div className="portfolio-hero-content">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Our Portfolio</h1>
            <p>
              Explore our successful projects and see how we've helped businesses achieve their digital goals
            </p>
          </motion.div>
        </div>
      </section>

      <section className="portfolio-content" ref={ref}>
        <div className="portfolio-container">
          <motion.div
            className="portfolio-filters"
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            {filters.map((filter) => (
              <motion.button
                key={filter.value}
                className={`filter-btn ${activeFilter === filter.value ? 'active' : ''}`}
                onClick={() => setActiveFilter(filter.value)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {filter.label}
              </motion.button>
            ))}
          </motion.div>

          <motion.div className="portfolio-grid-page" layout>
            {filteredProjects.map((project, index) => (
              <motion.div
                key={project.id}
                className="portfolio-card-page"
                layout
                initial={isMobile ? { opacity: 0, y: 20 } : { opacity: 0, scale: 0.9 }}
                animate={inView || isMobile ? { opacity: 1, scale: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: isMobile ? index * 0.1 : index * 0.05 }}
                whileHover={isMobile ? {} : { y: -10 }}
              >
                <div
                  className="portfolio-image-page"
                  style={{
                    ...(!project.video && !project.image ? {
                      background: project.gradient
                    } : {})
                  }}
                >
                  {project.video ? (
                    <video
                      src={project.video}
                      autoPlay
                      loop
                      muted
                      playsInline
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : project.image ? (
                    <img
                      src={project.image}
                      alt={project.title}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : null}
                  <div className="image-overlay-page">
                    <motion.div
                      className="overlay-content"
                      initial={{ opacity: 0, y: 20 }}
                      whileHover={{ opacity: 1, y: 0 }}
                    >
                      <Link to={`/portfolio/${project.id}`} className="view-details-btn">
                        View Details
                      </Link>
                    </motion.div>
                  </div>
                </div>

                <div className="portfolio-content-page">
                  <div className="project-meta">
                    <span className="project-client">{project.client}</span>
                    <span className="project-year">{project.year}</span>
                  </div>
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="portfolio-tags-page">
                    {project.tags.map((tag, i) => (
                      <span key={i} className="tag">{tag}</span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <section className="portfolio-cta-section">
        <div className="cta-content">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <h2>Have a Project in Mind?</h2>
            <p>Let's work together to bring your vision to life</p>
            <Link to="/contact">
              <motion.button
                className="cta-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Start Your Project
              </motion.button>
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PortfolioPage;
